import './App.css';
import View from './view';

function App() {
    return (
        <div className='App'>
            <View />
        </div>
    );
}

export default App;
